import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { BaseRbacRole } from 'api/types/userApiTypes'
import { OrgType } from 'components/admin-navbar/org-select/OrgMetadataSelect'

export const createOrgSchema = z.object({
  name: z.string().min(1, 'Organization name is required'),
  roles: z.array(z.string()),
  settings: z.record(z.string()).optional(),
  metadata: z.object({
    type: z.nativeEnum(OrgType),
  }),
})

export type CreateOrgFormValues = z.infer<typeof createOrgSchema>

const defaultValues: Partial<CreateOrgFormValues> = {
  name: '',
  roles: [BaseRbacRole.Admin, BaseRbacRole.Approver, BaseRbacRole.Editor, BaseRbacRole.Viewer],
  settings: undefined,
  metadata: {
    type: OrgType.Internal,
  },
}

const useCreateOrgFormMethods = () => {
  return useForm<CreateOrgFormValues>({
    resolver: zodResolver(createOrgSchema),
    defaultValues,
  })
}

export default useCreateOrgFormMethods
